import * as actionType from '../action-type';

export const updateTileReport = (data) => ({
  type: actionType.UPDATE_TILE_REPORT,
  payload: data,
});

export const resetTileReport = () => ({
  type: actionType.RESET_TILE_REPORT,
});
